import { HttpClient } from '@angular/common/http';
import { TranslocoLoader, TranslocoMissingHandler, TranslocoConfig, TRANSLOCO_MISSING_HANDLER, TranslocoTranspiler, HashMap, DefaultTranspiler, TranslocoService, TranslocoFallbackStrategy, TranslocoInterceptor, TranslateParams } from '@ngneat/transloco';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngneat/transloco";
/**
 * A service for export the loader for translation library.
 *
 * @export
 * @class HttpLoaderTranslateService
 * @implements {TranslocoLoader}
 */
export class HttpLoaderTranslateService {
    constructor(http) {
        this.http = http;
    }
    /**
     *
     *
     * {@inheritdoc}
     * @memberof HttpLoaderTranslateService
     */
    getTranslation(langPath) {
        const drupalSettings = window && window['drupalSettings'] ? window['drupalSettings'] : undefined;
        const drupalLang = (drupalSettings) ? drupalSettings['path']['currentLanguage'] : null;
        // Hardcode until we have a proper object.
        const drupalObjectLangAllowed = drupalSettings ? ['en', 'fr'] : null;
        const lang = drupalLang != null ? drupalLang : langPath.replace('/', '');
        const arrAllowed = (drupalObjectLangAllowed && drupalObjectLangAllowed.length > 0) ?
            drupalObjectLangAllowed : ['en', 'es', 'fr', 'sv', 'sl'];
        let setLang = '';
        // We need to force lang to english in drupal for get the translated text and use Drupal.t function.
        if (arrAllowed.indexOf(lang) > -1 && !drupalSettings) {
            setLang = arrAllowed.find(langInArr => langInArr === lang);
        }
        else {
            setLang = 'en';
        }
        return from(import('../../../modules/custom/wa_angular/app/assets/i18n/' + setLang + '.json'));
    }
}
HttpLoaderTranslateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HttpLoaderTranslateService_Factory() { return new HttpLoaderTranslateService(i0.ɵɵinject(i1.HttpClient)); }, token: HttpLoaderTranslateService, providedIn: "root" });
/**
 * Custom transpiler for avoid error when no strings are provided.
 *
 * @export
 * @class CustomTranspiler
 * @extends {DefaultTranspiler}
 * @implements {TranslocoTranspiler}
 */
export class CustomTranspiler extends DefaultTranspiler {
    transpile(value, params, translation) {
        let value_translated = super.transpile(value, params, translation);
        if (window && window['Drupal']) {
            value_translated = window['Drupal']['t'](value);
        }
        if (value_translated === '') {
            return value;
        }
        else {
            return value_translated;
        }
    }
}
/**
 * Custom transpiler for avoid error when no strings are provided.
 *
 * @export
 * @class CustomTranspiler
 * @extends {DefaultTranspiler}
 * @implements {TranslocoTranspiler}
 */
export class CustomTranslationService extends TranslocoService {
    constructor(loader, parser, missingHandler, interceptor, userConfig, fallbackStrategy) {
        super(loader, parser, missingHandler, interceptor, userConfig, fallbackStrategy);
    }
    /**
     * Gets the instant translated value of a key
     *
     * @example
     *
     * translate<string>('hello')
     * translate('hello', { value: 'value' })
     * translate<string[]>(['hello', 'key'])
     * translate('hello', { }, 'en')
     * translate('scope.someKey', { }, 'en')
     */
    translate(key, params = {}, lang = this.getActiveLang()) {
        let value_translated = super.translate(key, params, lang);
        if (window && window['Drupal']) {
            const translation = super.translate(key, params, this.getDefaultLang());
            value_translated = window['Drupal']['t'](translation);
        }
        return value_translated;
    }
}
CustomTranslationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomTranslationService_Factory() { return new CustomTranslationService(i0.ɵɵinject(i2.TRANSLOCO_LOADER, 8), i0.ɵɵinject(i2.TRANSLOCO_TRANSPILER), i0.ɵɵinject(i2.TRANSLOCO_MISSING_HANDLER), i0.ɵɵinject(i2.TRANSLOCO_INTERCEPTOR), i0.ɵɵinject(i2.TRANSLOCO_CONFIG), i0.ɵɵinject(i2.TRANSLOCO_FALLBACK_STRATEGY)); }, token: CustomTranslationService, providedIn: "root" });
/**
 * Method for preload to user lang.
 *
 * @export
 * @param {LanguageService} langService The lang service of rulebook.
 * @param {TranslocoService} transloco The translation service.
 * @returns
 */
export function preloadUserLang(langService, transloco) {
    return function () {
        return langService.lang().pipe(filter(a => a != undefined && a.LangID != undefined)).toPromise().then(({ lang }) => {
            transloco.setActiveLang(lang);
            return transloco.load(lang).toPromise();
        });
    };
}
export class CustomHandler {
    handle(key, config) {
        return '...';
    }
}
export const customMissingHandler = {
    provide: TRANSLOCO_MISSING_HANDLER,
    useClass: CustomHandler
};
